exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-tag[data-v-f71091dc] {\n  display: inline-block;\n  background: #03c2e6;\n  color: #fff;\n  font-size: 9px;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 1px 3px;\n  border-radius: 3px;\n}\n", ""]);

// exports
